import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Lock, LogIn, Loader2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/use-toast';

export default function PinLoginPage() {
  const [employeeId, setEmployeeId] = useState('');
  const [pin, setPin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { signInWithPin } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      await signInWithPin(employeeId, pin);
      toast({
        title: 'Bienvenido',
        description: 'Has iniciado sesión correctamente',
      });
      navigate('/');
    } catch (err) {
      console.error('Login error:', err);
      setError(
        err.message === 'Invalid employee ID or PIN'
          ? 'ID de empleado o PIN no válido. Por favor, intente de nuevo.'
          : err.message === 'Account is inactive'
          ? 'Su cuenta está inactiva. Contacte a soporte.'
          : 'Ocurrió un error al verificar sus credenciales. Contacte a soporte.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF9F3] flex items-center justify-center p-4">
      <div className="brand-card max-w-sm w-full text-center py-10">
        
        <img 
          src="https://www.puertoricoindex.com/img/pr/e/1692385721-99-st-james-security.png" 
          alt="St. James Security Logo"
          className="h-24 mx-auto mb-6"
        />

        <h1 className="text-2xl font-bold text-[#4B2E14] mb-2">
          Portal de Empleados
        </h1>
        <p className="text-[#4B2E14] opacity-80 mb-6">
          Ingrese su ID de empleado y PIN para acceder.
        </p>

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-[#C6A136]" />
            <Input
              type="text"
              placeholder="ID de Empleado"
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              className="pl-10 border-[#E2C77A] focus:border-[#C6A136] h-12"
              required
              disabled={isLoading}
            />
          </div>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-[#C6A136]" />
            <Input
              type="password"
              placeholder="PIN de 4 dígitos"
              maxLength="4"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              className="pl-10 border-[#E2C77A] focus:border-[#C6A136] h-12"
              required
              disabled={isLoading}
            />
          </div>

          {error && (
            <div className="bg-[#4B2E14] text-[#FFD33B] p-3 rounded-lg text-sm">
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={isLoading}
            style={{
              background: 'linear-gradient(145deg, #FFD33B, #C6A136)',
              border: 'none',
              borderRadius: '12px',
              padding: '0.75rem',
              color: '#4B2E14',
              fontWeight: '600',
              width: '100%',
              height: '3rem'
            }}
            className="flex items-center justify-center gap-2 hover:opacity-90"
          >
            {isLoading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                Verificando...
              </>
            ) : (
              <>
                <LogIn className="w-5 h-5" />
                Iniciar Sesión
              </>
            )}
          </Button>
        </form>
        
      </div>
    </div>
  );
}
